"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
function showUploadStatus() {
  return (0, _actionUtils.actionCreator)(_types.SET_UPLOAD_STATUS_VISIBILITY, true);
}
var _default = exports["default"] = showUploadStatus;